import { render } from "./MADynamics365Form.vue?vue&type=template&id=71a33fcb&ts=true"
import script from "./MADynamics365Form.vue?vue&type=script&lang=ts"
export * from "./MADynamics365Form.vue?vue&type=script&lang=ts"

import "./MADynamics365Form.vue?vue&type=style&index=0&id=71a33fcb&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__